import React, { useRef } from "react";
import { MessageModalContext } from "./MessageModalContext";
import MessageConfirmModal from "@/components/messageModal/MessageConfirmModal";

const MessageModalProvider = ({ children }) => {
  const messageModalRef = useRef("message");

  return (
    <MessageModalContext.Provider value={messageModalRef}>
      {children}
        <MessageConfirmModal textCentered ref={messageModalRef} />
    </MessageModalContext.Provider>
  );
};

export default MessageModalProvider;



// import to use:
// import { useMessageModal } from "@/components/messageModal/MessageModalContext";
// const messageModalRef = useMessageModal();